module.exports = __webpack_public_path__ + "img/carousel1.a77bc5ce.jpg";